import React from "react";
import { ButtonProps } from "@material-ui/core/Button";
import AppButton from "./AppButton";
import { makeStyles, createStyles } from "@material-ui/styles";
import clsx from "clsx";
import { StandardProps, Theme } from "@material-ui/core";
import { StyleClassKey } from "js/react/typescript";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        textButton: {
            padding: theme.spacing(0.5, 1),
            fontWeight: "bold",
            textTransform: "uppercase"
        }
    })
);

export type AppTextButtonClassKey = StyleClassKey<typeof useStyles>;
export interface AppTextButtonProps
    extends StandardProps<ButtonProps, AppTextButtonClassKey> {}

export function AppTextButton(props: AppTextButtonProps) {
    const classes = useStyles(props);
    const { className, ...rest } = props;

    return (
        <AppButton
            variant="text"
            className={clsx(classes.textButton, className)}
            {...rest}
        />
    );
}

export default AppTextButton;
